import { render, staticRenderFns } from "./PlaceholdersDetails.vue?vue&type=template&id=f3f52eea&"
import script from "./PlaceholdersDetails.vue?vue&type=script&lang=js&"
export * from "./PlaceholdersDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports